var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M10.002 14H4v-1.487h2.253l1.954-9.026H6V2h6v1.487H9.954L8 12.513h2.002z","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export default { render: render }